moment.fn.isWeekendDay = () ->
  dayOfWeek = @day()
  dayOfWeek == 0 || dayOfWeek == 6

moment.fn.isToday = () ->
  this.isSame(moment(), "day")



// WEBPACK FOOTER //
// ./app/javascript/vendor/moment.extend.js.coffee